// Portfolio data for Mohammad Ashraf
export const PROFILE = {
  name: "Mohammad Ashraf",
  firstName: "Mohammad",
  lastName: "Ashraf",
  title: "Backend Software Engineer",
  tagline: "I design distributed systems that handle 100k+ events a day without breaking a sweat.",
  location: "Aligarh, India",
  email: "mashrafkhan20161@gmail.com",
  phone: "+91 9369886780",
  resume: "https://drive.google.com/file/d/1m52PtLBtoNH-m5tmvF-SFFZW_ihYgFnF/view?usp=drive_link",
  socials: {
    github: "https://github.com/ashraf-0907",
    leetcode: "https://leetcode.com/u/ashraf_0907/",
    linkedin: "https://linkedin.com/in/mdashrafk",
    email: "mailto:mashrafkhan20161@gmail.com",
  },
};

export const SUMMARY = `Backend Software Engineer with 2 years of experience building scalable, event-driven distributed systems. I work across Node.js, TypeScript, Java, MongoDB and AWS — designing backend services that quietly chew through 100k+ events a day. I obsess over index optimization, API throughput, background job orchestration and the kind of architectural decisions you only see in the latency graph.`;

export const METRICS = [
  { value: "64GB", label: "Index size reduced", note: "MongoDB optimizations → 10% lower DB cost", testid: "metric-index-reduced" },
  { value: "100k+", label: "Events per day", note: "Real-time activity logging pipeline", testid: "metric-events-per-day" },
  { value: "4k+", label: "Daily export jobs", note: "Reliable background job orchestration", testid: "metric-exports-daily" },
  { value: "150+", label: "Billing transactions", note: "In 2 months, in-app billing platform", testid: "metric-transactions" },
  { value: "300k+", label: "Docs/hour processed", note: "Leaderboard via AWS SQS + Express", testid: "metric-docs-hour" },
  { value: "99%", label: "Offboarding automated", note: "Used by 15+ enterprise teams", testid: "metric-offboarding" },
];

export const EXPERIENCE = [
  {
    company: "Telecrm",
    role: "Software Engineer",
    location: "Aligarh, India",
    period: "Jun 2024 — Present",
    stack: ["Node.js", "TypeScript", "MongoDB", "AWS SQS", "Express.js", "Redis"],
    highlights: [
      "Designed MongoDB index optimizations that reduced index size by 64GB and lowered database costs by 10% while improving query latency and API throughput.",
      "Architected a backend activity logging system processing 100k+ events/day — real-time tracking of calls, notes, status changes and payments across enterprise tenants.",
      "Led design and development of an in-app billing & licensing platform; owned architecture decisions and code reviews, supporting 150+ transactions within 2 months and automating revenue metrics.",
      "Engineered a real-time leaderboard pipeline using AWS SQS and Express.js, processing 300k+ documents/hour for enterprise-scale user rankings.",
      "Built a high-throughput background export service supporting 100k rows per report and handling 4k+ daily export requests with reliable job orchestration.",
      "Implemented a flexible Recurring Date custom field system with complex filtering logic — monthly, quarterly, yearly triggers across 10k+ CRM records.",
      "Launched an automated enterprise user-deletion engine executing 99% of offboarding tasks autonomously, now used by 15+ teams.",
    ],
  },
];

export const PROJECTS = [
  {
    name: "Class-to-Zod",
    type: "npm library · open source",
    tagline: "TypeScript-first library that auto-generates Zod schemas from class definitions.",
    description:
      "Solves schema duplication across backend and frontend layers. Uses TypeScript AST/metadata to build a single source of truth for validation across MCP services, APIs and frontend clients. Reduces validation boilerplate by 50–70% and simplifies API contract management.",
    stack: ["TypeScript", "Zod", "MCP", "npm"],
    link: "https://github.com/ashraf-0907",
    cta: "View on GitHub",
    testid: "project-class-to-zod",
  },
  {
    name: "AMU Leaderboard",
    type: "side project",
    tagline: "Centralized academic benchmarking platform for AMU students.",
    description:
      "Backend service that fetches and parses student result data via APIs, normalizes it and generates comparative rankings and performance metrics. Students track academic progress through interactive graphs, statistics and semester-wise comparisons.",
    stack: ["Node.js", "Express", "MongoDB", "Data Pipelines"],
    link: "https://github.com/ashraf-0907",
    cta: "View on GitHub",
    testid: "project-amu-leaderboard",
  },
];

export const SKILLS = {
  Languages: ["Java", "JavaScript (ES6+)", "TypeScript", "C++", "SQL"],
  Backend: ["Node.js", "Express.js", "REST APIs", "Webhooks", "WebSockets", "Microservices"],
  "Databases & Cloud": ["MongoDB", "PostgreSQL", "MySQL", "Redis", "AWS Lambda", "AWS S3", "AWS SQS", "AWS SNS"],
  Frontend: ["Angular", "HTML5", "SCSS"],
  "Tools & Ops": ["Git", "GitHub", "Postman", "Linux", "CI/CD", "Jira"],
  "Auth & Security": ["JWT", "OAuth 2.0"],
};

export const EDUCATION = {
  school: "Zakir Husain College of Engineering and Technology",
  university: "Aligarh Muslim University",
  location: "Aligarh, India",
  degree: "B.Tech, Computer Engineering",
  period: "Nov 2020 — May 2024",
  cgpa: "8.77 / 10",
};

export const NAV = [
  { label: "About", href: "#about", testid: "nav-about" },
  { label: "Work", href: "#experience", testid: "nav-experience" },
  { label: "Projects", href: "#projects", testid: "nav-projects" },
  { label: "Skills", href: "#skills", testid: "nav-skills" },
  { label: "Contact", href: "#contact", testid: "nav-contact" },
];
